"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _analyticsUtils = require("../analyticsUtils");

var _reactRedux = require("react-redux");

var _analyticsDefaultProperties = require("../analyticsDefaultProperties");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var analyticsEnhance = function analyticsEnhance() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rules = (0, _analyticsUtils.expandRules)(options.ruleset);
  return function (ComposedComponent) {
    var AnalyticsEnhancedComponent = /*#__PURE__*/function (_React$Component) {
      (0, _inherits2.default)(AnalyticsEnhancedComponent, _React$Component);

      var _super = _createSuper(AnalyticsEnhancedComponent);

      function AnalyticsEnhancedComponent() {
        var _this;

        (0, _classCallCheck2.default)(this, AnalyticsEnhancedComponent);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
          trackedIds: {},
          loggedAnalyticsFailure: false
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getChildContext", function () {
          return {
            analyticsRules: rules,
            analyticsTrack: _this.track
          };
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "track", function (e, analyticsValues) {
          var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

          if (typeof window === 'undefined' && typeof window.analytics === 'undefined') {
            /* eslint no-console:0 */
            console.warn('Analytics not loaded - tracking event not completed');

            _this.setState({
              loggedAnalyticsFailure: true
            });
          }

          (0, _analyticsUtils.fireEachEvent)(e, analyticsValues, callback, _this.props.appState, window.analytics.track);
        });
        return _this;
      }

      (0, _createClass2.default)(AnalyticsEnhancedComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (typeof (rules || {}).page !== 'undefined' && !(0, _isEmpty2.default)(rules.page)) {
            setTimeout(function () {
              (0, _analyticsUtils.fireEachEvent)(window || {}, rules.page, function () {}, _this2.props.appState, window.analytics.page, (0, _analyticsDefaultProperties.getDefaultPageProps)(_this2.props.appState.config));
            }, 1000);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var filteredProps = (0, _omit2.default)(this.props, ['appState']);
          return /*#__PURE__*/_react.default.createElement(ComposedComponent, filteredProps);
        }
      }]);
      return AnalyticsEnhancedComponent;
    }(_react.default.Component);

    (0, _defineProperty2.default)(AnalyticsEnhancedComponent, "childContextTypes", {
      analyticsRules: _propTypes.default.object,
      analyticsTrack: _propTypes.default.func
    });
    AnalyticsEnhancedComponent.displayName = "AnalyticsEnhancedComponent(".concat(getDisplayName(ComposedComponent), ")");
    return (0, _reactRedux.connect)(function (state) {
      return {
        appState: state
      };
    })(AnalyticsEnhancedComponent);
  };
};

var _default = analyticsEnhance;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/legacy/analyticsEnhance.js
// module id = 3139
// module chunks = 25